import React from 'react';
import { UploadIcon } from './icons/UploadIcon';

export const FullScreenDropZone: React.FC = () => {
  return (
    <div
      className="fixed inset-0 bg-blue-500 bg-opacity-75 z-50 flex flex-col justify-center items-center backdrop-blur-sm pointer-events-none"
    >
      <div className="text-center text-white p-8 border-4 border-dashed border-white rounded-2xl bg-blue-500 bg-opacity-50">
        <UploadIcon className="w-24 h-24 mx-auto mb-4" />
        <h2 className="text-3xl font-bold">Pusťte soubory sem</h2>
        <p className="mt-2 text-lg">Účtenky budou automaticky nahrány a zpracovány.</p>
      </div>
    </div>
  );
};
